import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function AgentUpdateForm({ agentData }) {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    residentState: "",
    address: ""
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setFormData({
      firstName: agentData.firstName,
      lastName: agentData.lastName,
      email: agentData.email,
      telephone: agentData.telephone,
      residentState: agentData.residentState,
      address: agentData.address
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAgentUpdate = (event) => {
    event.preventDefault();

    const agentInformation = formData;

    API.updateAgent(agentData._id, agentInformation)
      .then((_res) => {
        cogoToast.success("Agent has been updated");
      })
      .catch((_err) => console.log(_err));
  };

  return (
    <div>
      <div className="card">
        <h3 style={{ textAlign: "center" }}>Update Agent</h3>

        <div className="card-body">
          <form>
            <Table bordered hover>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>First Name</td>
                  <td>
                    <input
                      type="text"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      name="firstName"
                      placeholder="First Name"
                    />
                  </td>

                  <td>Last Name</td>
                  <td>
                    <input
                      type="text"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      name="lastName"
                      placeholder="Last Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    <input
                      type="text"
                      value={formData.email}
                      onChange={handleInputChange}
                      name="email"
                      placeholder="E-mail"
                    />
                  </td>
                  <td>Phone</td>
                  <td>
                    <input
                      type="text"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      name="telephone"
                      placeholder="Phone #"
                    />
                  </td>
                </tr>

                <tr>
                  <td>Resident State</td>
                  <td>
                    <input
                      type="text"
                      maxLength="2"
                      value={formData.residentState}
                      onChange={handleInputChange}
                      name="residentState"
                      placeholder="Resident State"
                    />
                  </td>
                  <td>Full Address</td>
                  <td>
                    <input
                      type="text"
                      value={formData.address}
                      onChange={handleInputChange}
                      name="address"
                      placeholder="Complete Address"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>

            <div style={{ textAlign: "center" }}>
              <button className="btn-success btn-sm btn" onClick={(e) => handleAgentUpdate(e)}>
                Update Agent
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AgentUpdateForm;
